<script>
    import Switch from "./components/ui/Switch.svelte";
    import {toggleDarkMode} from "./config/app-state-config";

    const footerText = 'Created by myself with delight';
    const social = [
        {url: 'https://www.linkedin.com/in/matej-kormanik', icon: 'linkedin'},
        {url: 'https://github.com/Matej-Kormanik', icon: 'github'},
        {url: 'mailto:matej@kormanik.me', icon: 'envelope'},
        {url: 'https://www.instagram.com/matkormi/', icon: 'instagram'}
    ]

    function toggleDark(event) {
        toggleDarkMode(event.detail);
    }
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<footer>
    <nav class="left">
        {#each social as soc}
            <a href={soc.url} target='_blank' class='fa fa-{soc.icon}'><span></span></a>
        {/each}
    </nav>
    <Switch on:switch={toggleDark} />
    <h5>{footerText}</h5>
</footer>


<!--------------------------------------------------------------------------------------------------------------------->

<style>
    footer {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        border-top: 2px solid darkgray;
        height: 4rem;
        padding-bottom: 12px;
    }

    nav.left {
        flex-basis: 220px;
    }

    .fa {
        color: var(--black-color);
        padding: 4px;
        border: 1px solid var(--black-color);
        border-radius: 35%;
        margin-right: 5px;
    }

    a:not(:hover) {
        filter: opacity(0.6);
    }
    h5 {
        color: darkgray;
        flex-basis: 220px;
    }

    /*=======================================================================================*/
    /*==================================     MEDIA     ======================================*/

    @media screen and (max-width: 500px) {
        footer {display: none;}
    }
</style>
